<template>
	<loading-screen :condition="currentDocument" v-cloak>
		<template v-slot:content>
			<div class="quote-builder">
				<!-- <code>{{currentDocument.user}}</code> -->
				<v-card color="primary quote-builder__title-bar mb-3" dark>
					<v-card-title class="pa-0" style="height: 40px;">
						<v-spacer></v-spacer>
						<v-menu
							bottom
							left
							offset-x
							open-on-hover
							content-class="more-menu"
							v-if="!isCreate"
						>
							<v-btn small slot="activator" icon>
								<div class="v-icon">
									<fa-icon
										:icon="['far', 'ellipsis-v']"
										size="sm"
									/>
								</div>
							</v-btn>

							<v-list class="pa-0">
								<v-list-tile @click="deleteDocument">
									<v-list-tile-title
										>Delete</v-list-tile-title
									>
								</v-list-tile>
							</v-list>
						</v-menu>
					</v-card-title>
					<v-card-text
						class="pt-0 px-4 pb-3"
						style="margin-top: -16px;"
					>
						<v-layout row wrap align-end>
							<v-flex xs12 md6>
								<span>
									<span class="success--text">{{
										currentDocument.number
									}}</span>
									<span v-if="currentDocument.user"
										>&nbsp;&nbsp;|&nbsp;&nbsp;</span
									>
									<span v-if="currentDocument.user">{{
										currentDocument.user.company
									}}</span>
								</span>
								<div class="headline mb-1">
									<div class="d-inline-flex align-center">
										<span class="mr-2 font-weight-bold">{{
											currentDocument.name
										}}</span>

										<tooltip-menu
											title="How to Use This"
											v-if="isCreate"
										>
											Hello. I'm a tooltip. I'm here to
											help users know what to do. Tooltips
											can contain links for
											<router-link to="/dashboard"
												>more information</router-link
											>, too.
										</tooltip-menu>
									</div>
								</div>
								<span>
									<span v-if="currentDocument.proposal_date"
										>Proposed at:
										{{
											currentDocument.proposal_date
												| moment("MMM D YYYY")
										}}</span
									>

									<span v-if="currentDocument.ordered_at">
										<v-spacer></v-spacer>
										Ordered at:
										{{
											currentDocument.ordered_at
												| moment("MMM D YYYY")
										}}
									</span>
								</span>
							</v-flex>
							<v-flex xs12 md6>
								<div class="quote-progress">
									<v-progress-linear
										background-opacity="1"
										background-color="#F3F4F5"
										color="success"
										height="18"
										v-model="progress"
									></v-progress-linear>
									<div class="quote-progress__steps">
										<span
											v-for="route in routes"
											:key="route.step"
											:is="component(route)"
											:exact="!isCreate"
											:to="!isCreate ? route.path : false"
											:class="{
												disabled: isDisabled(route),
												'router-link-exact-active': checkAlternates(
													route
												),
												'router-link-active': checkAlternates(
													route
												)
											}"
											class="quote-progress__step"
											v-html="route.label"
										></span>
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-fade-transition mode="out-in" appear>
					<router-view
						:document="currentDocument"
						:key="$route.fullPath"
						class="quote-builder__route"
					></router-view>
				</v-fade-transition>
			</div>
		</template>
	</loading-screen>
</template>

<script>
import TooltipMenu from "@components/partials/TooltipMenu";
import LoadingScreen from "@components/partials/LoadingScreen";
import { mapActions } from "vuex";
import PathToRegexp from "path-to-regexp";

const { mainRoutes } = require("@root/mixins");

export default {
	mixins: [mainRoutes],

	data() {
		return {};
	},

	props: {
		number: {
			default: "create"
		}
	},

	components: { TooltipMenu, LoadingScreen },

	computed: {
		dayOfMonth() {
			return moment(this.currentDocument.proposal_date).date();
		},

		routes() {
			return _.sortBy(
				this.steps.reduce((carry, route) => {
					if (route !== null) {
						let additionalParams = {};

						if (this.number === "create") {
							additionalParams.number = "create";
						}

						let path = "";

						let needs_category = this.getObjectValue(
							"meta.needs_category",
							route,
							false,
							true
						);

						if (
							!needs_category ||
							(needs_category &&
								this.getObjectValue(
									"category",
									this.$attrs,
									""
								))
						) {
							if (
								needs_category &&
								this.getObjectValue("category", this.$attrs, "")
							) {
								additionalParams.category = this.getObjectValue(
									"category",
									this.$attrs,
									""
								);
							}

							if (
								!this.getObjectValue(
									"meta.needs_sku",
									route,
									false,
									true
								)
							) {
								path = this.getBuilderUrl(
									this.currentDocument,
									this.getObjectValue("meta.step", route),
									additionalParams
								);
							}
						}

						// if (this.getObjectValue("meta.clickable", route, false, true)) {
						// 	path = this.getBuilderUrl(
						// 		this.currentDocument,
						// 		this.getObjectValue("meta.step", route),
						// 		additionalParams
						// 	);
						// }

						carry.push({
							path,
							step: this.getObjectValue("meta.step", route, ""),
							label: this.getObjectValue("meta.title", route, ""),
							needs_category,
							needs_sku: this.getObjectValue(
								"meta.needs_sku",
								route,
								false,
								true
							),
							meta: route.meta
						});
					}

					// console.log(carry);

					return carry;
				}, []),
				"step"
			);
		},

		progress() {
			let matched = this.getObjectValue("matched", this.$route);

			for (let i = 0; i < matched.length; i++) {
				let value = this.getObjectValue(`meta.progress`, matched[i]);
				if (value !== null) {
					if (value === 100) {
						return 98;
					}
					return value;
				}
			}

			return 4;
		},

		events() {
			if (this.isCreate) {
				return "";
			}

			return "click";
		},

		component() {
			return route => {
				if (
					this.shouldBeDisabled(route.step) ||
					(this.isCreate && route.step === 1) ||
					this.disableForCategory(route.needs_category) ||
					this.disableForSku(route.needs_sku)
				) {
					return "span";
				}

				return "router-link";
			};
		},

		isDisabled() {
			return route =>
				this.shouldBeDisabled(route.step) ||
				this.disableForCategory(route.needs_category) ||
				this.disableForSku(route.needs_sku);
		},

		isActive() {
			return route => {
				return (
					this.getObjectValue("meta.step", this.$route) === route.step
				);
			};
		},

		checkAlternates() {
			return route => {
				let alternative_url = this.getObjectValue(
					"meta.alternative_url",
					route
				);

				if (alternative_url) {
					let rx = PathToRegexp(alternative_url);
					let matches = rx.exec(this.$route.path);

					if (matches) {
						// console.log("matches", matches);
						// console.log("matches[0]", matches[0]);
						// console.log(
						//   "matches[0] === this.$route.path",
						//   this.$route.path === matches[0]
						// );
						if (this.$route.path === matches[0]) {
							return true;
						}
					}
				}

				return false;
			};
		},

		disableForSku() {
			return needs_sku =>
				needs_sku && !this.getObjectValue("sku", this.$attrs, "");
		},

		disableForCategory() {
			return needs_category =>
				needs_category &&
				!this.getObjectValue("category", this.$attrs, "");
		}
	},

	methods: {
		...mapActions("documents", ["getDocuments"]),

		...mapActions("documents", {
			GET_DOCUMENTS: "getDocuments",
			DELETE_DOCUMENT: "deleteDocument"
		}),

		...mapActions("products", {
			GET_PRODUCTS: "getProducts",
			GET_CATEGORIES: "getCategories"
		}),

		deleteDocument() {
			if (this.isCreate) {
				return;
			}

			this.DELETE_DOCUMENT({
				number: this.number
			}).then(data => {
				if (this.getObjectValue("success", data, false)) {
					this.$router.push("/configurator");
				}
			});
		}
	},

	created() {
		// this.GET_PRODUCTS();
		this.GET_CATEGORIES();

		if (!this.currentDocument) {
			this.GET_DOCUMENTS({
				params: {
					orderby: "proposal_date"
				}
			});
		}
	}
};
</script>
